var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, nothing } from 'lit';
import { base64DecoderJSON, customElement, PICAction, PICBase, stringDecoder, booleanDecoder, submitEventHandler } from '../Internals';
import { classMap } from 'lit/directives/class-map.js';
import { property, query, queryAll } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';
let PICTree = class PICTree extends PICBase {
    set width(iwidth) {
        let widthParser = '324px';
        if (iwidth) {
            if (typeof iwidth === 'number' || iwidth.match(/^-?[0-9]*$/g)) {
                iwidth = parseFloat(iwidth);
                widthParser = iwidth + 'px';
            }
            else
                widthParser = iwidth;
        }
        this._width = widthParser;
        this.requestUpdate();
    }
    get width() {
        return this._width;
    }
    set maxheight(iheight) {
        let heightParser = '100%';
        if (iheight) {
            if (typeof iheight === 'number' || iheight.match(/^-?[0-9]*$/g)) {
                iheight = parseFloat(iheight);
                heightParser = iheight + 'px';
            }
            else
                heightParser = iheight;
        }
        this._maxheight = heightParser;
        this.requestUpdate();
    }
    get maxheight() {
        return this._maxheight;
    }
    //TODO add settable property 'height'. If 'maxheight' is also set, and is a smaller number than 'height', set 'height' to same value as 'maxheight'
    constructor() {
        super();
        this.selection = [];
        this.idMap = new Map();
        this.movedIds_ = { newParentId: undefined, movedItems: undefined };
        this.excludeContextClipboard = false;
        this.preventDragDrop = false;
        this.label = '';
        this._width = '324px';
        this._maxheight = '100%';
    }
    focus() {
    }
    get submitValue() {
        var _a, _b;
        if (this.selection.length === 0) {
            if (this.contextTarget)
                return (_a = this.contextTarget.Id) !== null && _a !== void 0 ? _a : '';
            return '';
        }
        else {
            let idstr = '';
            this.selection.forEach((elm) => idstr += `^${elm.Id}`);
            if (idstr.startsWith('^'))
                idstr = idstr.replace('^', '');
            if (this.contextTarget && !this.selection.includes(this.contextTarget))
                idstr = (_b = this.contextTarget.Id) !== null && _b !== void 0 ? _b : '';
            return idstr;
        }
    }
    get movedItems() {
        if (this.movedIds_.newParentId) {
            let returnStr = `${this.movedIds_.newParentId};${this.movedIds_.movedItems}`;
            return returnStr;
        }
        return '';
    }
    validateSubmit() {
        return true;
    }
    checkAndConsumeInlineData() {
        let iData = this.getAttribute('datafromprogress');
        if (iData) {
            this.mainItem = base64DecoderJSON(iData);
            if (typeof this.mainItem.contextMenu === 'string' && this.mainItem.contextMenu.length > 0) {
                let test = Object.values(base64DecoderJSON(this.mainItem.contextMenu))[0];
                this.mainItem.contextMenu = test;
            }
            this.requestUpdate();
        }
        this.removeAttribute('datafromprogress');
    }
    connectedCallback() {
        super.connectedCallback();
        this.checkAndConsumeInlineData();
        if (this.mainItem.Items)
            this.mainItem.Items.forEach(childItem => {
                childItem.Visible = true;
                childItem.Open = false;
            });
        this.populateIdMap(this.mainItem);
        window.PIC.addInput(this.id_, this);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.PIC.removeInput(this.id_);
    }
    populateIdMap(item) {
        this.idMap.set(item.Id, item);
        if (item.Items && item.Items.length > 0)
            item.Items.forEach((child) => { this.populateIdMap(child); });
    }
    addCMDListeners() {
        super.addCMDListeners();
        this.addEventListener('update', this.handleCMDUpdate.bind(this));
        this.addEventListener('create', this.handleCMDCreate.bind(this));
        this.addEventListener('delete', this.handleCMDDelete.bind(this));
        this.addEventListener('group', this.handleCMDCreateNewGroup.bind(this));
    }
    removeCMDListeners() {
        super.removeCMDListeners();
        this.removeEventListener('update', this.handleCMDUpdate.bind(this));
        this.removeEventListener('create', this.handleCMDCreate.bind(this));
        this.removeEventListener('delete', this.handleCMDDelete.bind(this));
        this.removeEventListener('group', this.handleCMDCreateNewGroup.bind(this));
    }
    handleCMDUpdate(e) {
        if (e.detail.data) {
            let uData = e.detail.data;
            if (uData.Id) {
                let found = this.idMap.get(uData.Id);
                if (found) {
                    if (uData.Color)
                        found.Color = uData.Color;
                    if (uData.Txt)
                        found.Txt = uData.Txt;
                    if (uData.ContextItem)
                        found.ContextItem = uData.ContextItem;
                    if (uData.Action)
                        found.Action = uData.Action;
                    if (uData.Symbol)
                        found.Symbol = uData.Symbol;
                    this.idMap.set(uData.Id, found);
                    this.clearSelection();
                    this.requestUpdate();
                }
                else
                    console.log(`Update failed - item id ${uData.Id} not found`);
            }
        }
    }
    handleCMDCreate(e) {
        if (e.detail.data) {
            let cData = e.detail.data;
            if (cData.Id && cData.ParentId) {
                if (this.idMap.get(cData.Id)) {
                    console.log(`Create failed - item with id ${cData.Id} already exists`);
                    return;
                }
                let parent = this.idMap.get(cData.ParentId);
                if (parent) {
                    this.createNewItem(parent, cData.Id, undefined, cData.Txt, cData.Color, cData.Symbol, cData.Action, cData.ContextItem);
                    this.clearSelection();
                    this.requestUpdate();
                }
                else
                    console.log(`Create failed - parent id ${cData.ParentId} not found`);
            }
        }
    }
    handleCMDDelete(e) {
        var _a, _b;
        if (e.detail.data) {
            let dData = e.detail.data;
            if (dData.Id) {
                let parent;
                let child = this.idMap.get(dData.Id);
                if (child) {
                    if (dData.ParentId) {
                        parent = this.idMap.get(dData.ParentId);
                        //check for parent mismatch
                        if (!(parent === null || parent === void 0 ? void 0 : parent.Items) || parent.Items.length === 0)
                            parent = undefined;
                        if (!((_a = parent === null || parent === void 0 ? void 0 : parent.Items) === null || _a === void 0 ? void 0 : _a.find((elm) => elm.Id === child.Id)))
                            parent = undefined;
                    }
                    if (!parent) {
                        this.idMap.forEach((item) => {
                            var _a;
                            let found = (_a = item.Items) === null || _a === void 0 ? void 0 : _a.find((elm) => elm.Id === child.Id);
                            if (found)
                                parent = item;
                        });
                    }
                    if (parent) {
                        (_b = parent.Items) === null || _b === void 0 ? void 0 : _b.splice(parent.Items.indexOf(child), 1);
                        this.deleteChildrenFromIDMap(child);
                        this.idMap.delete(dData.Id);
                        this.clearSelection();
                        this.requestUpdate();
                    }
                    else
                        console.log(`Delete failed - could not find item's parent`);
                }
                else
                    console.log(`Delete failed - item id ${dData.Id} not found`);
            }
        }
    }
    deleteChildrenFromIDMap(parent) {
        if (parent.Items && parent.Items.length > 0) {
            parent.Items.forEach((child) => {
                this.deleteChildrenFromIDMap(child);
                this.idMap.delete(child.Id);
            });
        }
    }
    handleCMDCreateNewGroup(e) {
        if (e.detail.data) {
            let gData = e.detail.data;
            if (gData.Id) {
                if (this.idMap.get(gData.Id)) {
                    console.log(`Grouping failed - item with id ${gData.Id} already exists`);
                    return;
                }
                let nodeParent;
                let nodeChildren = [];
                if (gData.ChildIds) {
                    gData.ChildIds.split('^').forEach((childId) => {
                        if (this.idMap.get(childId))
                            nodeChildren.push(this.idMap.get(childId));
                        else {
                            console.log(`Grouping failed - invalid child id ${childId}`);
                            return;
                        }
                    });
                }
                else {
                    if (this.selection.length > 0)
                        nodeChildren = this.selection;
                    else {
                        console.log(`Grouping failed - no valid items to group`);
                        return;
                    }
                }
                if (gData.ParentId)
                    nodeParent = this.idMap.get(gData.ParentId);
                if (!nodeParent) {
                    this.idMap.forEach((item) => {
                        var _a;
                        let found = (_a = item.Items) === null || _a === void 0 ? void 0 : _a.find((elm) => elm.Id === nodeChildren[0].Id);
                        if (found)
                            nodeParent = item;
                    });
                }
                if (nodeParent) {
                    let hasChildren = false;
                    let hasSameParent = true;
                    nodeChildren.forEach(child => {
                        var _a;
                        if (child.Items && child.Items.length > 0)
                            hasChildren = true;
                        if (!((_a = nodeParent.Items) === null || _a === void 0 ? void 0 : _a.find((elm) => elm.Id === child.Id)))
                            hasSameParent = false;
                    });
                    if (hasSameParent && !hasChildren) {
                        this.createNewItem(nodeParent, gData.Id, nodeChildren, gData.Txt, gData.Color, gData.Symbol, gData.Action, gData.ContextItem);
                        this.clearSelection();
                        this.requestUpdate();
                    }
                }
                else
                    console.log(`Grouping failed - parent ${gData.ParentId ? gData.ParentId : ''} not found`);
            }
        }
    }
    createNewItem(parent, id, items, txt, color, symbol, action, ctx) {
        var _a, _b, _c, _d, _e;
        let newItem = { Id: id, Items: [] };
        if (items) {
            newItem.Items = items;
            if (parent.Open)
                newItem.Open = true;
            else {
                items.forEach((item) => item.Visible = false);
                newItem.Open = false;
            }
        }
        if (txt)
            newItem.Txt = txt;
        if (color)
            newItem.Color = color;
        if (symbol)
            newItem.Symbol = symbol;
        if (action)
            newItem.Action = action;
        if (ctx)
            newItem.ContextItem = ctx;
        if (parent.Open)
            newItem.Visible = true;
        if (!items)
            (_a = parent.Items) === null || _a === void 0 ? void 0 : _a.push(newItem);
        else {
            let index = (_c = (_b = this.idMap.get(parent.Id)) === null || _b === void 0 ? void 0 : _b.Items) === null || _c === void 0 ? void 0 : _c.indexOf(items[0]);
            items.forEach(itm => {
                var _a;
                (_a = parent.Items) === null || _a === void 0 ? void 0 : _a.splice(parent.Items.indexOf(itm), 1);
            });
            if (index && index !== -1) {
                (_d = parent.Items) === null || _d === void 0 ? void 0 : _d.splice(index, 0, newItem);
            }
            else
                (_e = parent.Items) === null || _e === void 0 ? void 0 : _e.push(newItem);
        }
        parent.Visible = true;
        this.idMap.set(id, newItem);
        this.idMap.set(parent.Id, parent);
    }
    static get styles() {
        const defaultStyle = css `
      :host {
        --item-hover-bgcolor: var(--pic-primaryHoverColor);
        --item-selected-bgcolor: var(--pic-primaryActiveColor);
        --item-hover-selected-bgcolor: var(--pic-primaryFocusColor);
        --item-marker-color: var(--pic-primaryColor);
        --pic-outerListBorderColor: var(--pic-onSurfaceMediumColor);
        --tree-status-new-color: var(--pic-treeStatusNewColor, #5EAEB4);
        --tree-status-ready-color: var(--pic-treeStatusReadyColor, #78BC65);
        --tree-status-departed-color: var(--pic-treeStatusDepartedColor, #D9C005);
        --tree-status-done-color: var(--pic-treeStatusDoneColor, #A7A7A7);
        --tree-status-settled-color: var(--pic-treeStatusSettledColor, #9D81C9);
        --tree-status-canceled-color: var(--pic-treeStatusCanceledColor, #E05D5F);
        --tree-status-invalid-color: var(--pic-treeStatusInvalidColor, #E27000);
      }
      .outerContainer {
        display: flex;
        flex-flow: column nowrap;
        max-height: inherit;
        border-radius: 4px;
        border-color: var(--pic-outerListBorderColor);
        border-width: 1px;
        border-style: solid;
      }
      .pic-treeLabel {
        position: relative;
        width: fit-content;
        height: var(--pic-densityHighLabelHeight);
        left: 12px;
        top: -4px;
        padding: 0px 4px;
        background-color: var(--pic-backgroundColor, white);
        white-space: nowrap;
        font-size: 10px;
        line-height: 10px;
      }
      #outrLst {
        overflow: auto;
        margin-block-start: 0.5em;
        margin-block-end: 0.5em;
      }
      ul {
        list-style-type: '\u{F012E}';
        padding-inline-start: 25px;
      }
      ul li::marker {
        font-family: "Material Design Icons";
        font-size: medium;
        height: 12px;
        width: 12px;
        color: var(--item-marker-color);
      }
      ul li.parent {
        list-style-type: '\u{F09DA}';
      }
      ul li.parent.open {
        list-style-type: '\u{F09D6}';
      }
      li:hover {
        cursor: pointer;
        background-color: var(--item-hover-bgcolor);
      }
      .hidden {
        display: none;
      }
      .selected {
        background-color: var(--item-selected-bgcolor);
      }
      li.selected:hover {
        background-color: var(--item-hover-selected-bgcolor);
      }
      .borderTop{
        border-top: 2px solid var(--pic-primaryColor);
        transition: all 300ms ease-in
      }
      .borderBottom{
        border-bottom: 2px solid var(--pic-primaryColor);
        transition: all 300ms ease-in
      }
    `;
        return css `
      ${super.styles}
      ${defaultStyle}
    `;
    }
    setComponentInlineStyle() {
        this.style.setProperty('width', this.width);
        this.style.setProperty('min-width', this.width);
        this.style.setProperty('max-width', this.width);
        this.style.setProperty('max-height', this.maxheight);
    }
    getEm() {
        return window.getComputedStyle(this).fontSize ? parseInt(window.getComputedStyle(this).fontSize) : 16;
    }
    getContainerStyle() {
        let styles = [];
        if (this.label)
            styles.push({ 'margin-block-start': `${this.getEm() / 2}px` });
        if (!this.maxheight.match(/%/g) && parseFloat(this.maxheight) > this.getEm() / 2)
            styles.push({ 'max-height': `calc(${this.maxheight} - ${this.getEm() / 2 + 2}px)` });
        else
            styles.push({ 'max-height': `calc(100% - ${this.getEm() / 2 + 2}px)` });
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    getOuterListStyle() {
        let styles = [];
        if (this.label)
            styles.push({ 'margin-block-start': '0px' });
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    getItemStyle(item) {
        let styles = [];
        if (item.Symbol)
            styles.push({ 'list-style-type': `url(${item.Symbol})` });
        if (item.Color) {
            if (['NEW', 'READY', 'DEPARTED', 'DONE', 'SETTLED', 'CANCELED', 'INVALID'].includes(item.Color))
                styles.push({ '--item-marker-color': `var(--tree-status-${item.Color.toLowerCase()}-color)` });
            else
                styles.push({ '--item-marker-color': item.Color });
            styles.push({ '--item-hover-bgcolor': `rgb(from var(--item-marker-color) r g b / 10%)` });
            styles.push({ '--item-selected-bgcolor': `rgb(from var(--item-marker-color) r g b / 20%)` });
            styles.push({ '--item-hover-selected-bgcolor': `rgb(from var(--item-marker-color) r g b / 30%)` });
        }
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    getItemClass(item) {
        return {
            'pic-body2': true,
            'no-select': true,
            'hidden': item.Visible ? false : true,
            'selected': item.Selected ? true : false,
            'parent': item.Items && item.Items.length > 0 ? true : false,
            'open': item.Open ? true : false,
        };
    }
    getLabelClass() {
        return {
            'pic-caption': true,
            'pic-treeLabel': true,
        };
    }
    handleItemClick(item, e) {
        if (e.target && !e.ctrlKey) {
            if (e.shiftKey || typeof e.detail === 'boolean') {
                this.createSelection(item, e.target);
            }
            else {
                this.clearSelection();
                this.createSelection(item, e.target);
                if (item.Action) {
                    let action = new PICAction();
                    let optObj = {};
                    if (item.Action.type)
                        Object.assign(optObj, { 'type': item.Action.type });
                    if (item.Action.event)
                        Object.assign(optObj, { 'event': item.Action.event });
                    if (item.Action.pp)
                        Object.assign(optObj, { 'pp': item.Action.pp });
                    if (item.Action.parms)
                        Object.assign(optObj, { 'parms': item.Action.parms });
                    action.actionOptions = optObj;
                    action.parms_ += ',selectedvalues=' + item.Id;
                    if (item.Action.trigger)
                        action.trigger_ = item.Action.trigger;
                    action.triggerEvent(e);
                }
            }
        }
        if (e.ctrlKey && !e.shiftKey)
            this.toggleSelection(item, e.target);
        this.handleParentSelection();
        this.requestUpdate();
    }
    clearSelection() {
        this.selection.forEach((selectedItem) => {
            selectedItem.Selected = false;
        });
        this.selection = [];
        this.handleParentSelection();
    }
    handleParentSelection() {
        let listArr = Array.from(this.lists).reverse();
        listArr.forEach((list) => {
            if (!list.classList.contains('outerList')) {
                let selectParent = false;
                let children = Array.from(list.children);
                children.forEach((child) => {
                    let found = this.selection.find((element) => child.id === this.getLiId(element));
                    if (found) {
                        if (found.Selected)
                            selectParent = true;
                    }
                    else if (child.classList.contains('selected') && child.classList.contains('parent'))
                        selectParent = true;
                });
                let parent = list.previousElementSibling;
                if (parent && parent.classList.contains('parent')) {
                    if (selectParent && !parent.classList.contains('selected'))
                        parent.classList.add('selected');
                    if (!selectParent && parent.classList.contains('selected'))
                        parent.classList.remove('selected');
                }
            }
        });
    }
    createSelection(item, eTarget) {
        if (!this.selection || this.selection.length === 0) {
            this.selectionStart = eTarget;
            this.selectItem(item);
        }
        else { // new selection method - should be faster
            this.selectItem(item);
            // create array of li items in selection by cutting away items before first item's index, and after last item's index
            let testArr = Array.from(this.listItems);
            if (testArr.indexOf(this.selectionStart) > testArr.indexOf(eTarget)) {
                testArr.splice(0, testArr.indexOf(eTarget));
                testArr.length = (testArr.indexOf(this.selectionStart) + 1);
            }
            else {
                testArr.splice(0, testArr.indexOf(this.selectionStart));
                testArr.length = (testArr.indexOf(eTarget) + 1);
            }
            testArr.forEach((elm) => {
                let found = this.findByLiID(elm.id);
                if (found)
                    this.selectItem(found);
            });
            // maintain correct order in selection
            this.selection.sort((a, b) => {
                const indexA = testArr.findIndex((elm) => elm.id === this.getLiId(a));
                const indexB = testArr.findIndex((elm) => elm.id === this.getLiId(b));
                if (indexA < indexB)
                    return -1;
                if (indexA > indexB)
                    return 1;
                return 0;
            });
        }
    }
    findByLiID(liId) {
        let deLiified = liId;
        if (deLiified.startsWith('i'))
            deLiified = deLiified.replace('i', '');
        let found = this.idMap.get(liId) ? this.idMap.get(liId) : this.idMap.get(deLiified);
        if (!found)
            found = this.slowFindByLiID(this.mainItem, liId);
        return found;
    }
    slowFindByLiID(item, id) {
        if (this.getLiId(item) === id)
            return item;
        else if (item.Items && item.Items.length > 0) {
            for (let i = 0; i < item.Items.length; i++) {
                let itm = this.slowFindByLiID(item.Items[i], id);
                if (itm)
                    return itm;
            }
        }
    }
    selectItem(item) {
        item.Selected = true;
        if (!this.selection.includes(item))
            this.selection.push(item);
    }
    toggleSelection(item, eTarget) {
        if (!this.selection.includes(item)) {
            this.selectItem(item);
            this.selectionStart = eTarget;
        }
        else {
            this.selection.splice(this.selection.indexOf(item), 1);
            item.Selected = false;
            if (eTarget === this.selectionStart) {
                if (this.selection.length >= 1) {
                    this.selectionStart = Array.from(this.listItems).find((element) => element.id === this.getLiId(this.selection[this.selection.length - 1]));
                }
                else
                    this.selectionStart = undefined;
            }
        }
    }
    handleParentItemClick(item, e) {
        var _a;
        if (this.treeContext) {
            this.treeContext.shouldHide = true;
        }
        if (e && e.shiftKey) {
            this.selectItem(item);
            let liArr = Array.from(this.listItems);
            (_a = item.Items) === null || _a === void 0 ? void 0 : _a.forEach((child) => {
                var _a;
                if (!child.Items || child.Items.length === 0)
                    (_a = liArr.find((element) => element.id === this.getLiId(child))) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new CustomEvent('click', { detail: true }));
            });
        }
        else {
            item.Open = !item.Open;
            this.toggleShowChildItems(item);
        }
        this.requestUpdate();
    }
    toggleShowChildItems(item) {
        if (item.Items) {
            if (item.Open) {
                item.Items.forEach((child) => child.Visible = true);
            }
            else {
                item.Items.forEach((child) => {
                    child.Visible = false;
                    if (child.Items && child.Items.length > 0) {
                        child.Open === true ? this.handleParentItemClick(child) : '';
                    }
                });
            }
        }
    }
    getLiId(item) {
        var _a, _b;
        let onlyValidChars = (_b = (_a = item.Id) === null || _a === void 0 ? void 0 : _a.match(/[0-9a-zA-Z-_]*/g)) === null || _b === void 0 ? void 0 : _b.toString().replace(/,/g, ''); //TODO maybe just use CSS.escape instead of slapping an i on invalid ids?
        let prefix = (onlyValidChars === null || onlyValidChars === void 0 ? void 0 : onlyValidChars.match(/^\d+|^-+\d*/g)) ? 'i' : '';
        let validId = prefix + onlyValidChars;
        if (validId)
            return validId;
        else
            console.log('Invalid id', item.Id);
    }
    handleItemTextCopy(cellText) {
        navigator.clipboard.writeText(cellText);
    }
    getItemTextCopyContext(itemText) {
        return {
            menuTxt: 'Copy To Clipboard',
            eventTxt: itemText !== null && itemText !== void 0 ? itemText : '',
            eventFncKey: 'apiRequest',
            eventFnc: this.handleItemTextCopy.bind(this, itemText)
        };
    }
    handleContextMenu(event, item) {
        var _a;
        event.preventDefault();
        this.contextTarget = item;
        if (!this.selection.includes(item) && event.target) {
            this.clearSelection();
            if (event.target instanceof HTMLLIElement) {
                this.createSelection(item, event.target);
                this.requestUpdate();
            }
        }
        let ctxIds = this.selection.length > 0 && this.selection.includes(item) ?
            this.selection.map(item => { var _a; return (_a = item.Id) !== null && _a !== void 0 ? _a : ''; }).join('^') : (_a = item.Id) !== null && _a !== void 0 ? _a : '';
        if (this.mainItem.contextMenu && typeof this.mainItem.contextMenu !== 'string') {
            let context_ = [];
            if (!this.excludeContextClipboard && (this.selection.length === 0 || (this.selection.length === 1 && this.selection.includes(item))))
                context_.push(this.getItemTextCopyContext(item.Txt));
            if (typeof item.ContextItem === 'string') {
                let ctxarr = item.ContextItem.startsWith('%02') ? item.ContextItem.replace('%02', '').split('%02') : item.ContextItem.split('%02');
                ctxarr.forEach(elm => {
                    if (!elm.includes('%04')) {
                        console.log('Incorrect contextItem format', elm);
                        return;
                    }
                    let sub = elm.split('%04');
                    context_.push({ menuTxt: sub[0], eventTxt: sub[1] });
                });
            }
            this.mainItem.contextMenu.forEach(cont => {
                let ctx = {
                    menuTxt: cont.menuTxt,
                    eventTxt: cont.eventTxt,
                };
                if (cont.eventFncKey)
                    Object.assign(ctx, { eventFncKey: cont.eventFncKey });
                if (cont.subContext)
                    Object.assign(ctx, { subContext: cont.subContext });
                context_.push(ctx);
            });
            this.treeContext.data = {
                clickEvent: event,
                context: context_,
                selectedValues: ctxIds
            };
        }
    }
    copyLiItem(li) {
        let copy = li.cloneNode(true);
        let compStyle = window.getComputedStyle(li);
        copy.style.backgroundColor = compStyle.getPropertyValue('background-color');
        copy.style.width = compStyle.getPropertyValue('width');
        return copy;
    }
    createModifiedSelection() {
        let tmpSelection = structuredClone(this.selection);
        this.selection.reverse().forEach(selected => {
            var _a;
            if (selected.Items && ((_a = selected.Items) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                let allChildrenSelected = true;
                selected.Items.forEach(child => {
                    let found = this.selection.find((itm) => itm.Id === child.Id);
                    if (!found)
                        allChildrenSelected = false;
                });
                if (allChildrenSelected) {
                    // if a parent and all its children are selected, just select the parent
                    selected.Items.forEach(child => {
                        let found = tmpSelection.find((elm) => elm.Id === child.Id);
                        if (found)
                            tmpSelection.splice(tmpSelection.indexOf(found), 1);
                    });
                    // if a parent and only some of its children are selected, don't select the parent
                }
                else {
                    let found = tmpSelection.find((elm) => elm.Id === selected.Id);
                    if (found)
                        tmpSelection.splice(tmpSelection.indexOf(found), 1);
                }
            }
        });
        this.selection.reverse();
        return tmpSelection;
    }
    dragHandler(e, itemId) {
        let eventType = e.type;
        if (e.target && e.target instanceof HTMLLIElement) {
            if (eventType === 'dragstart' && itemId) {
                let ghost = document.getElementById(`${this.id_}-drag`);
                if (ghost && ghost.parentNode)
                    ghost.parentNode.removeChild(ghost);
                let transferData = '';
                let dragImage;
                if (this.selection.length > 0 && this.selection.find((elm) => elm.Id === itemId)) {
                    dragImage = document.createElement('ul');
                    this.createModifiedSelection().forEach(elm => {
                        transferData += `^${elm.Id}`;
                        let li = Array.from(this.allSelected).find((itm) => itm.id === this.getLiId(elm));
                        if (li)
                            dragImage === null || dragImage === void 0 ? void 0 : dragImage.appendChild(this.copyLiItem(li));
                    });
                    dragImage.id = `${this.id_}-drag`;
                    dragImage.style.position = 'absolute';
                    dragImage.style.top = '-1000px';
                    dragImage.style.listStyleType = 'none';
                    document.body.appendChild(dragImage);
                }
                else {
                    transferData = itemId;
                    dragImage = e.target;
                }
                if (transferData.startsWith('^'))
                    transferData = transferData.replace('^', '');
                if (e.dataTransfer) {
                    e.dataTransfer.setData('text/plain', transferData);
                    e.dataTransfer.setDragImage(dragImage, 0, 0);
                }
            }
            if (eventType === 'dragover') {
                e.preventDefault();
                if (e.dataTransfer)
                    e.dataTransfer.dropEffect = 'move';
                let top = e.target.getBoundingClientRect().top;
                let height = e.target.getBoundingClientRect().height;
                if (e.clientY > (top + height / 2)) {
                    e.target.classList.contains('borderTop') ? e.target.classList.remove('borderTop') : '';
                    !e.target.classList.contains('borderBottom') ? e.target.classList.add('borderBottom') : '';
                }
                if (e.clientY < (top + height / 2)) {
                    e.target.classList.contains('borderBottom') ? e.target.classList.remove('borderBottom') : '';
                    !e.target.classList.contains('borderTop') ? e.target.classList.add('borderTop') : '';
                }
            }
            if (eventType === 'dragleave') {
                if (e.target.classList.contains('borderTop'))
                    e.target.classList.remove('borderTop');
                if (e.target.classList.contains('borderBottom'))
                    e.target.classList.remove('borderBottom');
            }
        }
    }
    dropHandler(e, itemId) {
        var _a;
        let movedStr = (_a = e.dataTransfer) === null || _a === void 0 ? void 0 : _a.getData('text');
        let parentUl = e.target.parentElement;
        let parent;
        if (parentUl) {
            if (parentUl.id === 'outrLst')
                parent = this.mainItem;
            else if (parentUl.previousElementSibling)
                parent = this.findByLiID(parentUl.previousElementSibling.id);
        }
        if (movedStr && parent && parent.Items) {
            let moved = movedStr.split('^');
            //if the items have not been moved far enough
            if (moved.find((mId) => mId === itemId))
                return;
            let newSibling = this.idMap.get(itemId);
            moved.forEach(mId => {
                let itemToMove = this.idMap.get(mId);
                if (itemToMove)
                    this.moveFromOldParent(itemToMove);
            });
            let insertionIndex = newSibling ? parent.Items.indexOf(newSibling) : parent.Items.length - 1;
            if (e.target.classList.contains('borderBottom'))
                insertionIndex++;
            moved.forEach(mId => {
                let itemToMove = this.idMap.get(mId);
                if (itemToMove) {
                    this.moveToNewParent(itemToMove, parent, insertionIndex);
                    insertionIndex++;
                }
            });
            if (e.target.classList.contains('borderBottom'))
                e.target.classList.remove('borderBottom');
            if (e.target.classList.contains('borderTop'))
                e.target.classList.remove('borderTop');
            let ghost = document.getElementById(`${this.id_}-drag`);
            if (ghost && ghost.parentNode)
                ghost.parentNode.removeChild(ghost);
            this.movedIds_.newParentId = parent.Id;
            this.movedIds_.movedItems = movedStr;
            this.clearSelection();
            this.requestUpdate();
            submitEventHandler(undefined, 'tree-drag');
        }
    }
    moveFromOldParent(item) {
        var _a, _b;
        let oldParent;
        if (this.getLiId(item)) {
            let moveLi = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById(this.getLiId(item));
            let parentUl = moveLi === null || moveLi === void 0 ? void 0 : moveLi.parentElement;
            if (parentUl) {
                if (parentUl.id === 'outrLst')
                    oldParent = this.mainItem;
                else if (parentUl.previousElementSibling)
                    oldParent = this.findByLiID(parentUl.previousElementSibling.id);
            }
            if (oldParent) {
                (_b = oldParent.Items) === null || _b === void 0 ? void 0 : _b.splice(oldParent.Items.indexOf(item), 1);
                this.idMap.set(oldParent.Id, oldParent);
            }
        }
    }
    moveToNewParent(item, newParent, index) {
        var _a;
        (_a = newParent.Items) === null || _a === void 0 ? void 0 : _a.splice(index, 0, item);
        this.idMap.set(newParent.Id, newParent);
    }
    renderItemUL(item) {
        var _a;
        return html `<ul>${(_a = item.Items) === null || _a === void 0 ? void 0 : _a.map((i) => this.renderItem(i))}</ul>`;
    }
    renderItem(item, clickHandler) {
        if (!clickHandler)
            clickHandler = item.Items && item.Items.length > 0 ? (e) => this.handleParentItemClick(item, e) : (e) => this.handleItemClick(item, e);
        return html `
    <li @click=${clickHandler} 
      class=${classMap(this.getItemClass(item))}
      style=${styleMap(this.getItemStyle(item))}
      id=${ifDefined(this.getLiId(item))}
      .item=${item}
      draggable="true"
      @contextmenu=${(e) => this.handleContextMenu(e, item)}
      @dragstart=${this.preventDragDrop ? nothing : (e) => this.dragHandler(e, item.Id)}
      @dragover=${this.preventDragDrop ? nothing : (e) => this.dragHandler(e)}
      @dragleave=${this.preventDragDrop ? nothing : (e) => this.dragHandler(e)}
      @drop=${this.preventDragDrop ? nothing : (e) => this.dropHandler(e, item.Id)}
      >${item.Txt}
    </li>
    ${item.Items && item.Items.length > 0 ? this.renderItemUL(item) : ''}
    `;
    }
    render() {
        var _a;
        this.setComponentInlineStyle();
        return html `
      <div class="outerContainer" style=${styleMap(this.getContainerStyle())}>
        ${this.label ? html `<label class=${classMap(this.getLabelClass())} for="outrLst">${this.label}</label>` : ''}
        <ul id="outrLst" class="outerList" style=${styleMap(this.getOuterListStyle())}>
          ${(_a = this.mainItem.Items) === null || _a === void 0 ? void 0 : _a.map((i) => this.renderItem(i))}
        </ul>
      </div>
      <pic-context id="treeContext" mode="table"></pic-context>
    `;
    }
};
__decorate([
    queryAll('li')
], PICTree.prototype, "listItems", void 0);
__decorate([
    queryAll('ul')
], PICTree.prototype, "lists", void 0);
__decorate([
    queryAll('li.selected')
], PICTree.prototype, "allSelected", void 0);
__decorate([
    query('#treeContext')
], PICTree.prototype, "treeContext", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'excludecontextclipboard' })
], PICTree.prototype, "excludeContextClipboard", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'preventdragdrop' })
], PICTree.prototype, "preventDragDrop", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'label' })
], PICTree.prototype, "label", void 0);
__decorate([
    property({ type: String, attribute: 'width', reflect: false })
], PICTree.prototype, "width", null);
__decorate([
    property({ type: String, attribute: 'maxheight', reflect: false })
], PICTree.prototype, "maxheight", null);
PICTree = __decorate([
    customElement('pic-tree')
], PICTree);
export { PICTree };
//# sourceMappingURL=PICTree.js.map